import React from 'react';
import SEOHead from './components/SEOHead';
import { SITE_URL } from './utils/seo';
import MainHeader from './header/MainHeader';
import Footer from './footer/Footer';
import { useTranslation } from 'react-i18next';
import './auth.css';

function TermsAndConditions() {
  const { t } = useTranslation();

  return (
    <>
      <SEOHead
        title="Kushtet e Përdorimit - AutoPlace"
        description="Kushtet dhe rregullat e përdorimit të platformës AutoPlace. Lexo me kujdes përpara se të përdorësh shërbimin tonë."
        canonical={`${SITE_URL}/terms-and-conditions`}
      />
      <MainHeader />

      <div className="mysearch-section">
        <div className="mysearch-content">
          <h1>{t('terms.title')}</h1>
          <p className="text-white">{t('terms.last_updated')}</p>
        </div>
      </div>

      <section className="section_all py-5" id="terms-conditions">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div className="terms-content">
                <div className="mb-5">
                  <h2 className="font-weight-bold mb-3">
                    {t('terms.welcome')} <span className="text-custom">AutoPlace</span>
                  </h2>
                  <p className="mb-3">{t('terms.intro1')}</p>
                  <p className="mb-3">
                    <strong>{t('terms.intro2_bold')}</strong>{' '}
                    {t('terms.intro2_rest')}
                  </p>
                </div>

                <div className="mb-5">
                  <h3 className="font-weight-bold mb-3">{t('terms.s1_title')}</h3>
                  <p>{t('terms.s1_p1')}</p>
                  <p className="mt-2">{t('terms.s1_p2')}</p>
                </div>

                <div className="mb-5">
                  <h3 className="font-weight-bold mb-3">{t('terms.s2_title')}</h3>
                  <p>{t('terms.s2_intro')}</p>
                  <ul>
                    <li>{t('terms.s2_li1')}</li>
                    <li>{t('terms.s2_li2')}</li>
                    <li>{t('terms.s2_li3')}</li>
                    <li>{t('terms.s2_li4')}</li>
                    <li>{t('terms.s2_li5')}</li>
                  </ul>
                  <p className="mt-3">{t('terms.s2_note')}</p>
                </div>

                <div className="mb-5">
                  <h3 className="font-weight-bold mb-3">{t('terms.s3_title')}</h3>
                  <h5 className="font-weight-bold mt-4">{t('terms.s3_1_title')}</h5>
                  <p>{t('terms.s3_1_content')}</p>
                  <h5 className="font-weight-bold mt-4">{t('terms.s3_2_title')}</h5>
                  <p>{t('terms.s3_2_intro')}</p>
                  <ul>
                    <li>{t('terms.s3_2_li1')}</li>
                    <li>{t('terms.s3_2_li2')}</li>
                    <li>{t('terms.s3_2_li3')}</li>
                    <li>{t('terms.s3_2_li4')}</li>
                  </ul>
                  <h5 className="font-weight-bold mt-4">{t('terms.s3_3_title')}</h5>
                  <p>
                    <strong>{t('terms.s3_3_individual_label')}</strong> {t('terms.s3_3_individual')}
                    <br />
                    <strong>{t('terms.s3_3_dealer_label')}</strong> {t('terms.s3_3_dealer')}
                  </p>
                </div>

                <div className="mb-5">
                  <h3 className="font-weight-bold mb-3">{t('terms.s4_title')}</h3>
                  <h5 className="font-weight-bold mt-4">{t('terms.s4_1_title')}</h5>
                  <p>{t('terms.s4_1_intro')}</p>
                  <ul>
                    <li>{t('terms.s4_1_li1')}</li>
                    <li>{t('terms.s4_1_li2')}</li>
                    <li>{t('terms.s4_1_li3')}</li>
                    <li>{t('terms.s4_1_li4')}</li>
                    <li>{t('terms.s4_1_li5')}</li>
                  </ul>
                  <h5 className="font-weight-bold mt-4">{t('terms.s4_2_title')}</h5>
                  <p>{t('terms.s4_2_intro')}</p>
                  <ul>
                    <li>{t('terms.s4_2_li1')}</li>
                    <li>{t('terms.s4_2_li2')}</li>
                    <li>{t('terms.s4_2_li3')}</li>
                    <li>{t('terms.s4_2_li4')}</li>
                    <li>{t('terms.s4_2_li5')}</li>
                    <li>{t('terms.s4_2_li6')}</li>
                    <li>{t('terms.s4_2_li7')}</li>
                  </ul>
                </div>

                <div className="mb-5">
                  <h3 className="font-weight-bold mb-3">{t('terms.s5_title')}</h3>
                  <p>{t('terms.s5_content')}</p>
                </div>

                <div className="mb-5">
                  <h3 className="font-weight-bold mb-3">{t('terms.s6_title')}</h3>
                  <p>{t('terms.s6_intro')}</p>
                  <div className="mt-3">
                    <p><strong>{t('terms.s6_company')}</strong></p>
                    <p>{t('terms.s6_company_no')}</p>
                    <p>{t('terms.s6_address')}</p>
                    <p className="mt-3">
                      {t('terms.s6_email_label')}{' '}
                      <a href="mailto:legal@autoplace.al">legal@autoplace.al</a>
                      <br />
                      {t('terms.s6_support_label')}{' '}
                      <a href="mailto:support@autoplace.al">support@autoplace.al</a>
                    </p>
                  </div>
                </div>

                <div className="mb-5 p-4 bg-light rounded">
                  <h4 className="font-weight-bold mb-3">{t('terms.ack_title')}</h4>
                  <p className="mb-2">{t('terms.ack_p1')}</p>
                  <p className="mb-0">
                    <strong>{t('terms.ack_last_updated_label')}</strong> {t('terms.ack_last_updated')}
                    <br />
                    <strong>{t('terms.ack_effective_label')}</strong> {t('terms.ack_effective')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default TermsAndConditions;
